function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { withMedia } from 'react-media-query-hoc';
import { slugify } from '@domain-group/fe-helper';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { AllhomesDreamHomesCard } from './allhomes-dream-homes-card';
import * as styles from './allhomes-dream-homes.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BaseAllhomesDreamHomes = _ref => {
  var dreamhomes = _ref.dreamhomes,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$maxItems = _ref.maxItems,
    maxItems = _ref$maxItems === void 0 ? 3 : _ref$maxItems,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media;
  var mobile = media.mobile,
    tablet = media.tablet,
    desktop = media.desktop;
  var homes = dreamhomes.slice(0, maxItems);
  var isLarge = homes.length === 1;
  var fullWidthHeader = homes.length >= maxItems;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onClickHandler = (home, index) => () => {
    sendEvent('dream-home-click', {
      dreamHome: home,
      position: index
    });
    onClick(home, index);
  };
  return ___EmotionJSX("div", {
    css: styles.container
  }, (mobile || tablet) && ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.headingMobile
  }, ___EmotionJSX("h2", null, "Dream homes")), ___EmotionJSX("div", {
    css: styles.cardWrapperMobile
  }, homes.map((home, index) => ___EmotionJSX(AllhomesDreamHomesCard, _extends({
    isFirstCard: index === 0
  }, home, {
    onClick: onClickHandler(home, index),
    key: slugify(home.listingUrl)
  }))))), desktop && ___EmotionJSX("div", {
    css: styles.dreamHomes
  }, fullWidthHeader && ___EmotionJSX("div", {
    css: styles.headingOver
  }, ___EmotionJSX("h2", {
    css: styles.headingOverText
  }, "Dream homes")), ___EmotionJSX("div", {
    css: styles.wrapper
  }, !fullWidthHeader && ___EmotionJSX("div", {
    css: styles.heading(isLarge)
  }, ___EmotionJSX("h2", {
    css: styles.headingText(isLarge)
  }, "Dream homes")), homes.map((home, index) => ___EmotionJSX(AllhomesDreamHomesCard, _extends({
    isFirstCard: index === 0,
    isDesktop: true,
    isLarge: isLarge
  }, home, {
    onClick: onClickHandler(home, index),
    key: slugify(home.listingUrl)
  }))))));
};
var AllhomesDreamHomes = withMedia(BaseAllhomesDreamHomes);
export { AllhomesDreamHomes, BaseAllhomesDreamHomes };